import { api } from './apiClient';
import { EmailConfig } from '@/types/emailConfig';

export const emailConfigService = {
  getConfig: () =>
    api.get<EmailConfig>('/email-config/'),

  saveConfig: (config: EmailConfig) =>
    api.put<{ ok: boolean; id: number }>('/email-config/', config),

  testSend: (toEmail: string) =>
    api.post<{ ok: boolean; message?: string; error?: string }>(
      '/email-config/test',
      { to_email: toEmail }
    ),

  sendVoBo: (solicitudIds: string[]) =>
    api.post<{ ok: boolean; sent: number; errors: string[] }>(
      '/email-config/send-vobo',
      { solicitud_ids: solicitudIds }
    ),
};
